export default __webpack_public_path__ + "static/015-e8d1c69bc24e78d80c11de3e98cf2253.jpg";